module.exports = __webpack_public_path__ + "img/5.53d59a36.png";